/** @type {import('../help-index.js').HelpScreen} */
export const MEL_CON_HELP = {
  screenId: 'mel-con',
  label: 'Conectar',
  navPath: 'MercadoLibre → Conectar',
  keywords: ['oauth', 'vincular cuenta', 'publicaciones', 'token', 'mercadolibre'].map((k) => k.toLowerCase()),
  status: 'draft',
  summary: 'Vincular la cuenta de MercadoLibre de la empresa con Pyme Go mediante autorización OAuth.',
  sidebarItems: [{
    id: 'mel-connect',
    screenId: 'mel-con',
    label: 'Conexión con MercadoLibre',
    description: 'Autorizar, reconectar o renovar el token de la integración.',
    detail: {
      sections: [
        {
          title: 'Para qué sirve',
          intro: 'Permite que Pyme Go acceda a la cuenta de MercadoLibre de tu empresa para integrar publicaciones, ventas y otras operaciones.',
        },
        {
          title: 'Antes de empezar',
          bullets: [
            'Necesitás permiso de lectura del módulo MercadoLibre para ver el estado.',
            'Para conectar o renovar, permiso de conexión (mel.con).',
            'La base de datos del cliente debe tener la tabla de integración preparada; si falta, el estado lo indica.',
          ],
        },
        {
          title: 'Paso 1 — Ver el estado',
          bullets: [
            'Entrá a MercadoLibre → Conectar.',
            'El panel muestra si hay cuenta conectada, nombre, sitio, email y vencimiento del token.',
            'Si el token vence pronto, verás un aviso de renovación automática al usar la integración.',
          ],
        },
        {
          title: 'Paso 2 — Conectar o reconectar',
          steps: [
            'Tocá «Conectar con MercadoLibre» (o «Reconectar cuenta» si ya estaba vinculada).',
            'El navegador te lleva al sitio de MercadoLibre para autorizar la aplicación.',
            'Al terminar, volvés a Pyme Go con la cuenta vinculada.',
          ],
        },
        {
          title: 'Paso 3 — Renovar token (opcional)',
          paragraphs: [
            'Si la cuenta ya está conectada, podés usar «Renovar token» para forzar la actualización del acceso sin repetir todo el flujo OAuth.',
          ],
        },
      ],
    },
  }],
}
